var inputfile;

inputfile = function() {
  var $, moduleName;
  $ = require('jquery');
  moduleName = 'inputfile';
  return $('.' + moduleName + '__getfile').change(function() {
    var closeBtn, filename, files, getfile, i, self, str, thisFile, undefStroke, wrapper;
    self = $(this);
    files = this.files;
    wrapper = self.parent().parent('.' + moduleName);
    undefStroke = wrapper.find('.' + moduleName + '__files');
    getfile = wrapper.find('.' + moduleName + '__state');
    closeBtn = wrapper.find('.' + moduleName + '__cross');
    if (files && files.length === 1) {
      str = self.val();
      console.log(str);
      if (str.lastIndexOf('\\')) {
        i = str.lastIndexOf('\\') + 1;
      } else {
        i = str.lastIndexOf('/') + 1;
      }
      filename = str.slice(i);
      self.attr('value', str);
      undefStroke.addClass(moduleName + '__files--added');
      getfile.html(filename);
    }
    if (files && files.length > 1) {
      i = 0;
      undefStroke.addClass(moduleName + '__files--added');
      getfile.html("Файлов добавлено: " + files.length);
      while (i < files.length) {
        thisFile = files[i];
        console.log(thisFile);
        i++;
      }
    }
    return closeBtn.each(function() {
      var self2;
      self2 = $(this);
      return self2.click(function() {
        self.attr('value', '');
        undefStroke.removeClass(moduleName + '__files--added');
        return getfile.html('Файл не выбран');
      });
    });
  });
};

module.exports = inputfile;
